import React from "react";
import { Box } from "@mui/material";
import { starPoints } from "./ornamentShapes";

/**
 * A trophy with a star on the cup, drawn to whatever height the layout leaves
 * it. Ringed with small stars, or with short rays and a soft shadow under it.
 */
export const Trophy: React.FC<{
  colour: string;
  flourish?: "stars" | "rays";
}> = ({ colour, flourish = "stars" }) => (
  <Box
    component="svg"
    viewBox="-70 -64 140 128"
    aria-hidden="true"
    sx={{ height: "100%", maxHeight: 104, aspectRatio: "140 / 128" }}
  >
    {flourish === "rays" && (
      <ellipse cx={0} cy={58} rx={46} ry={6} fill={colour} opacity={0.15} />
    )}
    {/* Handles. */}
    <path
      d="M-30,-40 C-58,-40 -58,-6 -24,0 M30,-40 C58,-40 58,-6 24,0"
      fill="none"
      stroke={colour}
      strokeWidth={7}
      strokeLinecap="round"
    />
    {/* Cup, stem and base. */}
    <path d="M-34,-48 L34,-48 C34,-6 18,10 0,12 C-18,10 -34,-6 -34,-48 Z" fill={colour} />
    <path d="M-34,-48 L0,-48 L0,12 C-18,10 -34,-6 -34,-48 Z" fill="#ffffff" opacity={0.2} />
    <rect x={-6} y={10} width={12} height={20} fill={colour} />
    <rect x={-26} y={30} width={52} height={10} rx={3} fill={colour} />
    <rect x={-32} y={40} width={64} height={14} rx={3} fill={colour} />
    <polygon points={starPoints(5, 14, 6)} transform="translate(0 -22)" fill="#ffffff" />
    {flourish === "stars"
      ? [
          [-56, -48, 8],
          [58, -44, 9],
          [-62, 20, 6],
          [62, 26, 7],
          [0, -60, 6],
        ].map(([x, y, r]) => (
          <polygon
            key={`${x},${y}`}
            points={starPoints(5, r, r * 0.45)}
            transform={`translate(${x} ${y})`}
            fill={colour}
          />
        ))
      : // Three short rays out from each side of the cup.
        [-1, 1].flatMap((side) =>
          [-30, -16, -2].map((y, i) => (
            <line
              key={`${side},${y}`}
              x1={side * 58}
              y1={y}
              x2={side * 68}
              y2={y + (i - 1) * 6}
              stroke={colour}
              strokeWidth={4}
              strokeLinecap="round"
            />
          )),
        )}
  </Box>
);
